import { NOMINEE } from '../../../../redux-store/types/nct';
import { NOMINEEINFO } from './update-nominee-edit';

export interface NomineeInfoRowData {
    amc?: string;
    amcName: string;
    id: string | number;
    mobile?: string;
    investorName?: string;
    nominees: NOMINEE[];
    assetType?: string[];
    taxStatusLabel: string;
}

export const getPinCode = (ele: NOMINEEINFO, isKfin: boolean, address: any) => {
    if (isKfin) {
        if (ele.addressSameAsFH === 'Y') {
            if (address?.country !== 'India') {
                return 0;
            }
            return address?.pincode;
        }
        if (ele.country !== 'India') {
            return 0;
        }
        return ele.pincode;
    } else {
        return ele.addressSameAsFH === 'Y' ? 0 : ele.pincode;
    }
};
